import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';

export const ButtonList: FCC = ({ children }) => <div className="button-list">{children}</div>;
